// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3yceV","amount":"Amount_amount__1O88p","tip":"Amount_tip__3qBF4","tipHeader":"Amount_tipHeader__C-t3_","tipsWrap":"Amount_tipsWrap__2suFf"};